<template>
  <v-container class="pa-0" fluid>
    <!-- <material-card icon="mdi-clipboard-text" inline title="Servicesss"> -->
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="3" lg="2" class="my-0 py-0">
          <div clasuccessss="d-flex grow flex-wrap">
            <div class="ml-2">
              <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                Services Type
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4" lg="2"
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }">
          <span class="body-2 font-weight-medium ma-1"> From date</span>
          <custom-date-picker dense :maxToDate="maxToDate" v-model.trim="fromDate" />
        </v-col>
        <v-col cols="12" md="4" lg="2">
          <span class="body-2 font-weight-medium"> To date</span>
          <span>
            <custom-date-picker dense :minToDate="fromDate" v-model.trim="toDate" />
          </span>
        </v-col>
        <v-col cols="12" md="4" lg="3">
          <span class="body-2 ml-5 font-weight-medium"> Search</span>
          <v-text-field class="ml-5" dense v-model="search" placeholder="value to search..." />
        </v-col>
        <v-col cols="12" md="4" lg="2" class="d-flex align-center justify-end">
          <v-btn small color="primary" type="submit" @click="
              () => {
                getServices(), (page = 1)
              }
            ">
            <v-icon left> mdi-magnify </v-icon>
            Search
          </v-btn>
          <v-btn class="d-flex justify-end ml-4" small elevation="1" @click="
              () => {
                modalOk = true
              }
            " :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table v-if="tableData.length > 0" :headers="headers" :items="tableData"
        :custom-filter="mycFilter" :search="search" disable-pagination hide-default-footer>
        <template v-slot:item.isActive="{ item }">
          {{ item.isActive ? 'YES' : 'NO' }}
        </template>
        <template v-slot:item.serviceFranchiseeMaps="{ item }">
          <p v-for="values in item.serviceFranchiseeMaps" :key="values.id">
            {{ values.franchisee.companyName }}</p>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn v-if="item.isActive" color="success" class="px-2 ml-1 ma-1"
            @click="getSingle(item)" min-width="0" small>
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>

          <v-btn color="error" v-if="item.isActive" class="px-2 ml-1 ma-1"
            @click="statusUpdate(item.id)" min-width="0" small>
            <v-icon small> mdi-trash-can-outline </v-icon>
          </v-btn>
          <v-btn color="info" v-else class="px-2 ml-1 ma-1" @click="statusUpdate(item.id)"
            min-width="0" small>
            <v-icon small> mdi-reload </v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
      <v-col v-if="tableData.length != 0">
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="10"
              @input="handlePageChange"></v-pagination>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <v-dialog persistent v-model="modalOk" max-width="900" :active="modalOk" :on-cancel="
        () => {
          modalOk = false
          clearData()
        }
      ">
      <form @submit.prevent="addService">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> {{ editMode ? 'Edit' : 'Add' }} Service</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="
                  () => {
                    ;(modalOk = false), clearData()
                  }
                ">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="Name *" v-model.trim="serviceName" placeholder="Service Name"
                  required> </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="Provider" v-model.trim="providerName"
                  placeholder="Provider Name"> </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-autocomplete class="mt-4" :disabled="editMode" required label="Category *" clearable
                  v-model="categoryId" :items="categories" key="id" item-value="id"
                  item-text="name"> </v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-row>
                  <v-col cols="12" md="7">
                    <v-autocomplete :required="franchiseeIds.length === 0" multiple
                      label="Franchisee *" clearable v-model="franchiseeIds"
                      @change="franchiseeChange" :items="franchiseeList" key="id" item-value="id"
                      item-text="companyName">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-checkbox class="ma-0 mt-5 pa-0" label="Select All"
                      v-model="franchiseeSelectAll" @change="selectAllToggle"></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <label class="font-weight-medium body-2"> Description *</label>
                <ckeditor required v-model="description" ref="ckeditorRef1"></ckeditor>
              </v-col>
              <v-col cols="12">
                <label class="font-weight-medium body-2">isAdmitted</label>
                <v-switch v-model="admitted" :label="admitted ? 'true' : 'false'" color="primary">
                </v-switch>
              </v-col>

              <v-col cols="12">
                <v-card-actions class="justify-end">
                  <v-btn color="success" type="submit">Save</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>

    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import _ from 'lodash'
// import VCardComponent from '@/components/template/VCardComponent'
// import MaterialCard from '@/components/template/MaterialCard'
export default {
  components: { CustomDatePicker },
  data () {
    return {
      selectedId: '',
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100],
      selectedFranchiseeID: [],
      fromDate: moment().subtract(12, 'month').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      maxToDate: moment().format('YYYY-MM-DD'),
      search: '',
      headers: [
        { text: 'Service name', value: 'name' },
        { text: 'Service Category', value: 'serviceCategory.name' },
        { text: 'provider name', value: 'providerName' },
        { text: 'Franchisee', value: 'serviceFranchiseeMaps', sortable: false },
        { text: 'Academic year', value: 'franchiseeAcademicYear.academicYear' },
        { text: 'Is Active', value: 'isActive' },
        { text: 'Actions', value: 'actions', align: 'center' }
      ],
      inProgress: false,
      tableData: [],
      isLoading: false,
      isWrite: true,
      modalOk: false,
      categories: [],
      providerName: '',
      serviceName: '',
      description: '',
      editMode: false,
      categoryId: '',
      franchiseeList: [],
      franchiseeIds: [],
      prevfranchiseeIds: [],
      admitted: false,
      franchiseeSelectAll: false
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },

  async created () {
    //   this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.onFranchiseeChange()
    await this.getCategories()
    await this.getFranchisee()
  },
  methods: {
    selectAllToggle () {
      this.franchiseeIds = this.franchiseeSelectAll
        ? this.franchiseeList.map((item) => {
          return item.id
        })
        : []
    },
    franchiseeChange () {
      this.franchiseeSelectAll = this.franchiseeList.length === this.franchiseeIds.length
    },
    mycFilter (value, search, item) {
      search = search.toLowerCase()
      return (
        !!search &&
        (item.academicYearID.toString().includes(search) ||
          item.franchiseeAcademicYear.academicYear.includes(search) ||
          item.name.toLowerCase().includes(search) ||
          item.providerName.toLowerCase().includes(search) ||
          item.serviceCategory.name.toLowerCase().includes(search) ||
          item.serviceFranchiseeMaps.some((a) => a.franchisee.companyName.toLowerCase().includes(search)))
      )
    },
    statusUpdate: async function (id) {
      this.$dialog.warning({
        text: 'Are you sure, you want to change status ?',
        title: 'Warning',
        actions: {
          false: 'No',
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.get(`${CONSTANTS.API_URL}/api/service/type/status/${id}`)
                this.okMsg('Status updated successfully!')
                await this.getServices()
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    getSingle: async function (item) {
      this.serviceName = item.name
      this.description = item.description || ''
      this.providerName = item.providerName
      this.categoryId = item.categoryID

      let franchArr = _.map(item.serviceFranchiseeMaps, (a) => a.franchisee.id)
      console.log(franchArr, 'Array1')
      this.selectedId = item.id
      this.modalOk = true
      this.editMode = true
      this.franchiseeIds = franchArr
      this.prevfranchiseeIds = franchArr
    },
    addService: async function () {
      let frArr = _.map(this.franchiseeIds, (a) => {
        return {
          franchiseeID: a,
          isActive: true
        }
      })
      // console.log('My Array', frArr)
      try {
        this.isLoading = true

        if (this.editMode) {
          // Editing the Service Type
          this.prevfranchiseeIds.forEach((item) => {
            let index = _.findIndex(
              this.franchiseeIds,
              (e) => {
                return e === item
              },
              0
            )
            if (index === -1) {
              // Previously this option is enabled now it is disabled
              frArr.push({
                franchiseeID: item,
                isActive: false
              })
            }
          })
          await http.post(`${CONSTANTS.API_URL}/api/service/type/${this.selectedId}`, {
            name: this.serviceName,
            providerName: this.providerName,
            description: this.description,
            franchisee: frArr,
            isAdmitted: this.admitted
          })
        } else {
          // Creating new Service Type
          await http.post(`${CONSTANTS.API_URL}/api/service/type`, {
            name: this.serviceName,
            description: this.description,
            providerName: this.providerName,
            categoryID: this.categoryId,
            academicYearID: this.academicYearID,
            franchisee: frArr,
            isActive: true,
            isAdmitted: this.admitted
          })
        }

        this.okMsg('Record saved successfully!')
        this.clearData()
        this.modalOk = false
        this.page = 1
        await this.getServices()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    filterFranchisee () {
      this.leadsData = []
      this.selectedRow = []
      this.franchiseeList = _.filter(this.franchiseeList, (a) => !this.selectedFranchiseeID.includes(a.id))
      console.log(this.selectedFranchiseeID)
    },
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/franchisee/active`)
        this.franchiseeList = res.data.rows
        console.log(this.franchiseeList, 'Show listing all')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getCategories: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/service/category/list/?isActive=true`)
        this.categories = res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getServices: async function () {
      try {
        this.filterFranchisee()
        const paramData = {}
        paramData.academicYearID = this.academicYearID
        // paramData.franchiseeID = _.map(this.selectedFranchiseeID, 'id').join(',')
        paramData.franchiseeID = this.franchiseeID
        if (this.fromDate) {
          paramData.fromDate = this.fromDate
        }
        if (this.toDate) {
          paramData.toDate = this.toDate
        }
        paramData.page = this.page - 1
        paramData.size = this.pageSize
        paramData.search = this.search
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/service/type`, {
          params: paramData
        })
        this.tableData = res.data.rows
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange (value) {
      this.page = value
      this.getServices()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getServices()
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getServices()
      } else {
        this.page = 1
        this.getServices()
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.academicYearID) {
          await this.getServices()
        }
        if (this.franchiseeID) {
          await this.getServices()
        }
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    clearData () {
      this.serviceName = ''
      this.franchiseeIds = []
      this.providerName = ''
      this.categoryId = ''
      this.selectedId = ''
      this.editMode = false
    }
  }
}
</script>

<style lang="css" scoped>
</style>
